import type { ComponentInfo } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const trustPilotReviewsWidgetInputs = [
  {
    name: "disableForCurrentPage",
    friendlyName: "Disable Trust Pilot for Current Page",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "styleHeight",
    friendlyName: "Widget Height",
    type: "string",
    defaultValue: "150px",
  },
  {
    name: "styleWidth",
    friendlyName: "Widget Width",
    type: "string",
    defaultValue: "100%",
  },
  {
    name: "stars",
    friendlyName: "Stars Filter",
    type: "string",
    defaultValue: "1,2,3,4,5",
    description: "Comma-separated list of star ratings to display (e.g. '4,5' to show only 4 and 5 star reviews)",
  },
  {
    name: "reviewsPerPage",
    friendlyName: "Reviews Per Page",
    type: "string",
    defaultValue: "15",
  },
  {
    name: "sku",
    friendlyName: "Product SKU",
    type: "string",
    description: "Optional product SKU for product-specific reviews. If empty, business-unit reviews are shown.",
  },
] as const satisfies ComponentInfo["inputs"];

export type TrustPilotReviewsWidgetProps = BuilderComponentProps<typeof trustPilotReviewsWidgetInputs>;

export const TrustPilotReviewsWidgetComponent: RegisteredComponent = {
  name: "TrustPilotReviewsWidget",
  friendlyName: "Trust Pilot Reviews Widget",
  component: dynamic(async () =>
    withValidation(
      trustPilotReviewsWidgetInputs,
      (await import("./TrustPilotReviewsWidget")).TrustPilotReviewsWidget,
      "TrustPilotReviewsWidget"
    )
  ),
  inputs: trustPilotReviewsWidgetInputs,
};
